import { Text, TouchableHighlight, View } from 'react-native';

export default function ToolbarButton({ label, tapped, altTapped }) {
  const handlePress = () => {
    if (tapped) tapped();
  };

  const handleLongPress = () => {
    if (altTapped) altTapped();
  };

  const styles = {
    toolbarButton: {
      height: 35,
      width: 45,
      justifyContent: 'center',
      alignItems: 'center',
    },

    toolbarText: {
      fontSize: 24,
      fontWeight: 'bold',
      color: 'white',
      textAlign: 'center'
    }
  };

  return (
    <TouchableHighlight 
      onPress={handlePress}
      onLongPress={handleLongPress} 
      delayLongPress={3000} 
      underlayColor="white"
    >
      <View style={styles.toolbarButton}>
        <Text style={styles.toolbarText} allowFontScaling={false}>
          {label}
        </Text>
      </View>
    </TouchableHighlight>
  );
}
